(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5809],{

/***/ 75302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25378);




/* harmony default export */ __webpack_exports__["ZP"] = ({
  useBreakpoint: _hooks_useBreakpoint__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z
});

/***/ }),

/***/ 42264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member",
      function () {
        return __webpack_require__(59365);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 59365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71577);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20228);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(15746);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8100);
/* harmony import */ var _tidb_community_datasource__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74685);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21679);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62675);
/* harmony import */ var _index_styled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84017);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63683);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83454);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(process__WEBPACK_IMPORTED_MODULE_9__);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var Page = function() {
    var isReady = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().isReady;
    var ref5 = (0,swr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(isReady && [
        "points.getMe"
    ]), data = ref5.data, mutate = ref5.mutate;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(isReady && [
        "asktug.getBadgesList"
    ]), badges = ref1.data;
    var pointsData = data === null || data === void 0 ? void 0 : data.data;
    var badgesData = badges === null || badges === void 0 ? void 0 : badges.badges;
    var badgesDataOrdered = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var ref;
        var has = (ref = badgesData === null || badgesData === void 0 ? void 0 : badgesData.filter(function(value) {
            return value.has_badge;
        })) !== null && ref !== void 0 ? ref : [];
        var ref4;
        var notHas = (ref4 = badgesData === null || badgesData === void 0 ? void 0 : badgesData.filter(function(value) {
            return !value.has_badge;
        })) !== null && ref4 !== void 0 ? ref4 : [];
        return _toConsumableArray(has).concat(_toConsumableArray(notHas));
    }, [
        badgesData
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), checkInMessage = ref2[0], setCheckInMessage = ref2[1];
    var checkIn = function() {
        var _ref = _asyncToGenerator(_home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _home_runner_work_community_website_community_website_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _tidb_community_datasource__WEBPACK_IMPORTED_MODULE_10__.checkIn();
                    case 2:
                        res = _ctx.sent;
                        if (res.data) {
                            setCheckInMessage("\u6210\u529F\u7B7E\u5230\uFF01\n\u8FDE\u7EED\u7B7E\u5230 ".concat(res.data.continues_checkin_count, " \u5929, \u6210\u529F\u83B7\u5F97 ").concat(res.data.points, " \u79EF\u5206\u5956\u52B1\n\u3002\u660E\u5929\u7EE7\u7EED\u7B7E\u5230\u53EF\u83B7\u5F97 ").concat(res.data.tomorrow_points, " \u79EF\u5206\u3002"));
                            setIsModalVisible(true);
                        }
                        _ctx.next = 6;
                        return mutate();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkIn() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isModalVisible = ref3[0], setIsModalVisible = ref3[1];
    var handleOk = function() {
        setIsModalVisible(false);
    };
    var handleCancel = function() {
        setIsModalVisible(false);
    };
    var meData = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_context__WEBPACK_IMPORTED_MODULE_6__/* .MeContext */ .io).meData;
    if (!data || !badges || !meData) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_5__/* .PageLoader */ .wY, {})
    });
    var _NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Title */ .Dx, {
                children: "\u4F1A\u5458\u7B49\u7EA7"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .LevelContainer */ .q, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Name */ .VG, {
                                        children: meData.username
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Level */ .aC, {
                                        children: [
                                            "V",
                                            pointsData.current_level
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                type: "primary",
                                onClick: checkIn,
                                disabled: pointsData.is_today_checked,
                                children: !pointsData.is_today_checked ? "\u7B7E\u5230" : "\u5DF2\u7B7E\u5230"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                title: "\u7B7E\u5230\u6210\u529F",
                                visible: isModalVisible,
                                onOk: handleOk,
                                onCancel: handleCancel,
                                footer: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        onClick: handleCancel,
                                        children: "\u5173\u95ED"
                                    }, "back"), 
                                ],
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    children: checkInMessage
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        align: "middle",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .ExpLabel */ .wS, {
                                children: " \u7ECF\u9A8C\u503C "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Score */ .BE, {
                                children: pointsData.current_exps
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Rank */ .yw, {
                                children: [
                                    "/\u6392\u540D ",
                                    pointsData.current_rank
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u, {
                        align: {
                            offset: [
                                -16,
                                0
                            ],
                            // @ts-ignore
                            targetOffset: [
                                -pointsData.level_desc.progress * 100 + "%",
                                0
                            ]
                        },
                        placement: "topLeft",
                        title: "\u5F53\u524D\u7ECF\u9A8C\u503C ".concat(pointsData.current_exps),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Progress */ .Ex, {
                            showInfo: false,
                            percent: pointsData.level_desc.progress * 100
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Tip */ .Ch, {
                        children: [
                            "\u8FD8\u5DEE ",
                            pointsData.level_desc.max_exps - pointsData.current_exps,
                            " \u7ECF\u9A8C\u5347\u7EA7\u4E3A V",
                            pointsData.current_level + 1,
                            "\uFF0C\u67E5\u770B",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .rU, {
                                fontSize: "14px",
                                href: "/member/rules",
                                children: "\u5347\u7EA7\u5C0F\u653B\u7565"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Title */ .Dx, {
                children: [
                    "\u5FBD\u7AE0\u6210\u5C31",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Count */ .XF, {
                        children: [
                            badgesData.filter(function(v) {
                                return v.has_badge;
                            }).length,
                            " / ",
                            badgesData.length
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .BadgesContainer */ .Gk, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    gutter: [
                        16,
                        8
                    ],
                    children: badgesDataOrdered.map(function(badge) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            xs: 12,
                            md: 8,
                            lg: 6,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .Badge */ .Ct, {
                                owned: badge.has_badge,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .BadgeIcon */ .Vh, {
                                        src: "".concat((_NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL = "https://pingkai.cn/tidbcommunity/forum") !== null && _NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL !== void 0 ? _NEXT_PUBLIC_ASKTUG_WEBSITE_BASE_URL : "", "/").concat(badge.image_url)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_index_styled__WEBPACK_IMPORTED_MODULE_7__/* .BadgeName */ .EZ, {
                                        children: badge.name
                                    })
                                ]
                            })
                        });
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Page);


/***/ }),

/***/ 84017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ Score; },
/* harmony export */   "Cg": function() { return /* binding */ Tutorial; },
/* harmony export */   "Ch": function() { return /* binding */ Tip; },
/* harmony export */   "Ct": function() { return /* binding */ Badge; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "EZ": function() { return /* binding */ BadgeName; },
/* harmony export */   "Ex": function() { return /* binding */ Progress; },
/* harmony export */   "Gk": function() { return /* binding */ BadgesContainer; },
/* harmony export */   "VG": function() { return /* binding */ Name; },
/* harmony export */   "Vh": function() { return /* binding */ BadgeIcon; },
/* harmony export */   "XF": function() { return /* binding */ Count; },
/* harmony export */   "aC": function() { return /* binding */ Level; },
/* harmony export */   "q": function() { return /* binding */ LevelContainer; },
/* harmony export */   "rU": function() { return /* binding */ Link; },
/* harmony export */   "u": function() { return /* binding */ Tooltip; },
/* harmony export */   "wS": function() { return /* binding */ ExpLabel; },
/* harmony export */   "yw": function() { return /* binding */ Rank; }
/* harmony export */ });
/* unused harmony exports Subscript, Container, Main */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
/* harmony import */ var _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22745);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21679);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36084);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58008);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-bottom: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: 6px;\n  width: 100%;\n  padding: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  margin-right: 4px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: bold;\n  margin-left: 0.5rem;\n  color: #e30c34;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  font-size: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  // gradient from left to right, orange to red\n  border: 1px solid ",
        ";\n  padding: 4px 8px;\n  margin-right: 4px;\n  border-radius: 1rem;\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: #be1d32;\n  transform: translateY(-4px);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 1rem;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-top: 2rem;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: none;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  // two columns with equal width; first is icon, second is name\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  border-radius: 6px;\n  background-color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-align: left;\n  font-size: 14px;\n  position: relative;\n  padding-left: 1rem;\n\n  &:before {\n    position: absolute;\n    top: 3px;\n    left: 0;\n    content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12.71' height='12.71' viewBox='0 0 12.71 12.71'%3E%3Cpath id='Icon_simple-gratipay' data-name='Icon simple-gratipay' d='M12.71,6.355A6.355,6.355,0,1,1,6.355,0,6.355,6.355,0,0,1,12.71,6.355ZM8.94,3.96a1.3,1.3,0,0,0-1.751.3A.973.973,0,0,1,6.4,4.6a.973.973,0,0,1-.79-.336,1.3,1.3,0,0,0-1.75-.3A1.316,1.316,0,0,0,3.51,5.8L6.4,9.718,9.291,5.8a1.318,1.318,0,0,0-.35-1.843Z' fill='%23f8c200'/%3E%3C/svg%3E%0A\");\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  padding-left: 4px;\n  font-weight: 300;\n  color: #c7c7c7;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1 !important;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}

// @ts-ignore

// @ts-ignore


var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .typography */ .cp("h3"));
var LevelContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject1(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.M1);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject2(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.F2);
var Level = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject3());
var Score = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject4(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1);
var ExpLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject5(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1, _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1);
var Rank = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Name)(_templateObject6());
var Subscript = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject7(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .typography */ .cp("p2"));
var Tip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject8(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .typography */ .cp("p2"), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.F2);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject9(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_components__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU)(_templateObject10(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1);
var Main = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject11());
var BadgesContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject12());
var Badge = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject13(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.M1, function(props) {
    return !props.owned && "filter: grayscale(100%)}; opacity: 50%;";
});
var BadgeIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .ZP.img(_templateObject14());
var BadgeName = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject15());
var Tutorial = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject16(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.F1);
var Tooltip = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject17());
var Count = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject18());
var Progress = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject19());


/***/ }),

/***/ 63683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/member/layout/layout.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #e9eaee;\n  padding-bottom: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-top: 2rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), mixins/* responsive */.jW());
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 8 modules
var menu = __webpack_require__(58928);
;// CONCATENATED MODULE: ./src/pages/member/layout/menu/menu.styled.js
function menu_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styled_templateObject() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  background: none;\n  border: none;\n\n  .ant-menu-item {\n    margin: 0 !important;\n  }\n"
    ]);
    menu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styled_templateObject1() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  list-style: none;\n  border: 1px solid ",
        ";\n"
    ]);
    menu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_styled_templateObject2() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      cursor: default;\n      border-left: 4px solid ",
        ";\n      background: ",
        " !important;\n    "
    ]);
    menu_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  display: block;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  cursor: pointer;\n  padding: 0 1rem;\n  transition: color 0.25s ease;\n  color: ",
        " !important;\n  &:not(:last-child) {\n    margin-bottom: 0.5rem;\n  }\n  &:hover {\n    color: ",
        " !important;\n  }\n  height: 40px;\n  line-height: 40px;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MobileMenu = (0,styled_components_browser_esm/* default */.ZP)(menu/* default */.Z)(menu_styled_templateObject());
var menu_styled_Container = styled_components_browser_esm/* default.ul */.ZP.ul(menu_styled_templateObject1(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.T2);
var Item = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3(), colors.F1, colors.B1, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(menu_styled_templateObject2(), colors.B1, colors.M1);
});

;// CONCATENATED MODULE: ./src/pages/member/layout/menu/Menu.component.js




var Menu = function(param) {
    var isMobile = param.isMobile;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var pathPrefix = "/member";
    var routes = {
        "": "\u4F1A\u5458\u4E2D\u5FC3",
        "/redeem": "\u79EF\u5206\u5151\u6362",
        "/records": "\u79EF\u5206\u8BB0\u5F55",
        "/rules": "\u79EF\u5206\u89C4\u5219"
    };
    var handleMobileClick = function(e) {
        var key = e.key;
        router.push(key);
    };
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
            mode: "horizontal",
            selectedKeys: [
                asPath
            ],
            onClick: handleMobileClick,
            children: Object.keys(routes).map(function(path) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu.Item, {
                    children: routes[path]
                }, pathPrefix + path);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_styled_Container, {
        children: Object.keys(routes).map(function(path) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                isActive: pathPrefix + path === asPath || path !== "" && pathPrefix + path + "/records" === asPath,
                onClick: function(e) {
                    e.preventDefault();
                    router.push(pathPrefix + path);
                },
                children: routes[path]
            });
        })
    });
};
/* harmony default export */ var Menu_component = (Menu);

;// CONCATENATED MODULE: ./src/pages/member/layout/menu/index.js


// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
;// CONCATENATED MODULE: ./src/pages/member/layout/Layout.component.js









var Layout = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(context/* AuthContext */.Vo), setIsAuthRequired = ref.setIsAuthRequired, isAnonymous = ref.isAnonymous, login = ref.login;
    (0,react.useEffect)(function() {
        setIsAuthRequired(true);
        return function() {
            return setIsAuthRequired(false);
        };
    }, [
        setIsAuthRequired
    ]);
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    if (isAnonymous) {
        login();
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
            MainWrapper: Wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                    title: "\u4F1A\u5458\u4E2D\u5FC3",
                    description: "\u6B22\u8FCE\u6765\u5230\u4F1A\u5458\u4E2D\u5FC3\uFF01\u6765\u8FD9\u91CC\u67E5\u770B\u5347\u7EA7\u5C0F\u653B\u7565\uFF0C\u83B7\u53D6\u66F4\u591A\u79EF\u5206\u548C\u7ECF\u9A8C\uFF0C\u89E3\u9501\u66F4\u9AD8\u7EA7\u7684\u8363\u8A89\u6210\u5C31\uFF01"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: [
                            32,
                            32
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_component, {
                                    isMobile: isSmallScreen
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 16,
                                md: 18,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                                    children: children
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/member/layout/index.js



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,469,9774,2888,179], function() { return __webpack_exec__(42264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);